export default __webpack_public_path__ + "static/media/PAGE-6.81072e05.zip";